module.exports = __webpack_public_path__ + "assets/f05c4d641f4883104eb26dcf6de18062.png";